import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Admissionleft from './Admissoinleft';
import { Container,Row, Col, Button,Table } from 'react-bootstrap';



function Btech_AdmissionELe() {
    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col md={4} className='c-left mb-4'>
                        <Admissionleft activeIndex={5} />
                    </Col>

                    <Col md={8} className='c-left me-8'>
                        <div className="c-heading">
                            <h3>Bachelor of Technology </h3> <br/>
                        </div>
                        
                        <div className="border border-dark">
                            <div className="p-3">
                                <div id="about">
                                   
                                    <p className="caboutus">IIT Tirupati offers B.Tech. degree in Chemical Engineering, Civil Engineering, Computer Science and Engineering, Electrical Engineering, Mechanical Engineering and Physics. The admissions are made through JEE (Advanced). For more details visit <b className='c-link'><Link to="/fee-structure" className='c-link'>https://jeeadv.ac.in/</Link>. </b> <br /> <br/>

                                        <span>The applicable tuition and other fee / deposits for B.Tech students is available at the following <Link to="/fee-structure" className='c-link'>link</Link>.
                                    </span>
                                    </p>
                                    {/* <p className="caboutus">The PM-Vidyalaxmi Scheme, a Government of India initiative offering collateral-free and guarantor-free education loans is available for all meritorious students who are getting admission in this Institution and who are desirous of availing education loans to pursue higher education. You can visit the portal <b><Link to="https://pmvidyalaxmi.co.in" className="c-link">Click Here</Link></b>. The portal does not charge any amount from the applicant.</p> */}
                                   
                                     <Table bordered responsive className='mt-3'>
                                                                        <thead>
                                                                            <tr>
                                                                                <th colSpan="2" className="text-center">
                                                                                    <h4 className="text-primary">Important Dates</h4>
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>Reporting to Campus</td>
                                                                                <td>25th July 2026</td>
                                                                                
                                                                            </tr>
                                                                            <tr>
                                                                                <td>In-Person Registration cum Document Verification at IIT Tirupati</td>
                                                                                <td>27th July 2026</td>
                                                                                    {/* <td><s><b>Monday, 2nd December 2024</b></s> <b>Monday, 16th December 2024 (Latest by 9 A.M.) </b><br /><span className="text-primary">(Students may plan to arrive on campus from December 14, 2024 onwards)</span></td> */}
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Date of Orientation Program</td>
                                                                                <td>27th July 2026</td>
                                                                                
                                                                            </tr>
                                    
                                                                            <tr>
                                                                                <td>Commencement of classes</td>
                                                                                <td>3rd August 2026</td>
                                                                            </tr>

                                                                             <tr>
                                                                                <td>Last Date for submission of all Pending Documents</td>
                                                                                <td>30th September 2026</td>
                                                                            </tr>
                                    
                                                                        </tbody>
                                                                    </Table>


                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>

        </section>
    );
}

export default Btech_AdmissionELe;
